import { IconButton } from '@material-tailwind/react'
import React from 'react'

/**
 * Reusable ProfileLinkCard
 * Props:
 * - icon: React element to show on the left (optional)
 * - title: main title text
 * - subtitle: smaller subtitle text (optional)
 * - rightText: text shown on the right (optional)
 * - onClick: click handler (optional)
 * - className: extra classes for container (optional)
 * - showChevron: show right chevron (default: true)
 */
const ProfileLinkCard = ({
  icon,
  title = 'Title',
  subtitle = '',
  rightText = '',
  onClick = undefined,
  className = '',
  showChevron = true,
}) => {
  const DefaultIcon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M2 10a6 6 0 0110-4.472V6a2 2 0 002 2h2a1 1 0 010 2h-2v4a2 2 0 01-2 2H8a6 6 0 01-6-6z" />
    </svg>
  )

  const Chevron = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-4 w-4 text-gray-500"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 111.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clipRule="evenodd" />
    </svg>
  )

  return (
    <button
      type="button"
      onClick={onClick}
      className={
        `w-full flex items-center justify-between gap-3 p-3 bg-white rounded-md hover:bg-gray-50 transition ${className}`
      }
    >
      <div className="flex items-center gap-3">
        <div className="flex-shrink-0 w-5 h-5 rounded-full text-gray-700 flex items-center justify-center">
          {icon || DefaultIcon}
        </div>

        <div className="text-left">
          <div className="text-sm font-medium text-gray-800">{title}</div>
          {subtitle ? (
            <div className="text-xs text-debatePalette-bodyText">{subtitle}</div>
          ) : null}
        </div>
      </div>

      <div className="flex items-center gap-2">
        {rightText ? (
          <div className="text-sm text-debatePalette-bodyText">{rightText}</div>
        ) : null}
        {showChevron ? (
          <span className="flex items-center">{Chevron}</span>
        ) : null}
      </div>
    </button>
  )
}

export default ProfileLinkCard